import { TEmployeeRenewVisaDocumentStepGroup } from "@/api/entities/employee-renew-visa-document-step-group.entity";
import { useGetRenewVisaResidenceCardInformationGroupList } from "@/api/services/main/renew-visa";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { ResidenceCardInfoStepCard } from "@/features/renew-visa/components/residenceCardInfoStep/ResidenceCardInfoStepCard";
import { FC } from "react";

export type TRenewVisaResidenceCardInfoStepProps = {
  stepGroupData: TEmployeeRenewVisaDocumentStepGroup;
  isFinishAfterSubmitApplicationResultStep: boolean;
  readonly: boolean;
  isExistBasicInfoData: boolean;
};

export const RenewVisaResidenceCardInfoStep: FC<TRenewVisaResidenceCardInfoStepProps> = ({
  stepGroupData,
  readonly,
  isExistBasicInfoData,
  isFinishAfterSubmitApplicationResultStep,
}) => {
  const { id: renewVisaDocumentStepGroupId } = stepGroupData;
  const {
    data: applicationInformationGroupListData,
    isLoading,
    isFetching,
  } = useGetRenewVisaResidenceCardInformationGroupList({
    renewVisaDocumentStepGroupId,
    enabled: isFinishAfterSubmitApplicationResultStep,
  });

  if (isLoading || isFetching) return <LoadingArea />;

  return (
    <ResidenceCardInfoStepCard
      isExistBasicInfoData={isExistBasicInfoData}
      readonly={readonly}
      residenceCardInformationGroupListData={applicationInformationGroupListData ?? []}
      stepGroupData={stepGroupData}
    />
  );
};
